<div
  class="relative w-full"
  [pTooltip]="tooltip()"
  tooltipPosition="top"
  [tooltipOptions]="{ showDelay: 300, tooltipStyleClass: 'ces-syntax-tooltip' }">
  <div class="flex flex-row items-center gap-1 w-full">
    <ces-fast-date-range-input
      class="flex-1 min-w-0"
      [ngModel]="model()"
      [ngModelOptions]="{ standalone: true }"
      (rangeChange)="onRangeChange($event)"
      [ariaLabel]="'common.dateRange.rangeAriaLabel' | transloco" />
    @if (isFilterActive()) {
      <button
        type="button"
        [attr.aria-label]="getClearAriaLabel()"
        class="flex items-center justify-center shrink-0 min-w-6 min-h-6"
        (click)="onClear($event)">
        <ces-icon size="sm" containerSize="xs">close</ces-icon>
      </button>
    }
  </div>
</div>
